<div class="user-settings-container" #rootElement>
  <div class="user-settings-top-level">
    <!-- 2 rows - the body, then the button bar -->
    <div class="us-body-row">
      <!-- 2 Cols - the button bar then the main settings window -->
      <div
        class="user-settings-buttons bfx-section-wrapper us-category-col bfx-segmented-group-container-sm bfx-segmented-group-container-subtle-enabled"
      >
        <!-- Button bar -->
        <ng-container *ngFor="let tab of tabNames; let i = index">
          <button
            *ngIf="isSettingPageAvailable(i)"
            pButton
            type="button"
            class="settings-category bfx-segmented-control-md"
            [ngClass]="{
                'bfx-segmented-control-subtle-unselected-md':activeCategory!=i,
                'bfx-segmented-control-subtle-selected-md':activeCategory==i
              }"
            (click)="activeCategory = i"
            iconPos="right"
            [icon]="categoryValid[i] === BfxUserSettingsValidityState.INVALID ? 'icon-warning icon-primary' : 'fa'"
            [disabled]="tab.disabled"
          >
            <span class="label-primary">{{tab.name}}</span>
          </button>
        </ng-container>
        <div class="flex-spacer"></div>
      </div>

      <!-- Body-->
      <div
        class="user-settings-components us-category-settings"
        valign="top"
        [nativeDesktopStyle]="{ 'font-size' : '12px' }"
      >
        <!-- Please Update USER_SETTINGS_TABS in BfxUserSettingsComponent if changing the order of these children -->
        <div
          class="bfx-general-settings user-settings-component"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.General"
        ></div>
        <div
          class="bfx-order-blotter-settings user-settings-component"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.Order"
        ></div>
        <div
          class="bfx-bmark-summary-settings user-settings-component"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.BmarkSummary"
        ></div>
        <div
          class="bfx-order-entry-settings user-settings-component"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.OrderEntry"
        ></div>
        <div
          class="bfx-notification-settings user-settings-component overflow-hidden"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.Notification"
        ></div>
        <div
          class="bfx-panic-controls-settings user-settings-component"
          nativeDesktopClass="user-settings-native-desktop"
          #settingComponent
          [hidden]="activeCategory!=BfxUserSettingsCategoryIndex.Panic"
        ></div>
      </div>
    </div>
    <!-- THe button bar-->
    <div class="us-action-row">
      <button
        class="bfx-button-secondary-subtle"
        pButton
        label="Revert"
        [disabled]="revertDisabled"
        (click)="revert()"
      ></button>
      <button
        class="bfx-button-primary"
        pButton
        label="Save"
        [disabled]="saveDisabled"
        (click)="save()"
      ></button>
    </div>
  </div>
</div>
